module.exports = __webpack_public_path__ + "static/media/img-corner-arrow.1d3d86b9.svg";